export function createPage1Content(): string {
  return `<div>This is the content of page 1</div>`;
}
